import { useQuery } from "@tanstack/react-query";

import { getFetch } from "config/fetch";
import {baseURL} from 'constants/baseUrl';
import * as queryKeys from "utils/queryKeys";
import { generateUrlSearchString } from "./utils/generateUrlSearchString";


const activitiesRequest = async (data) =>
  await getFetch(`${baseURL}/activity/activities`, "GET", {}, data);

export const useGetActivitiesQuery = () =>
useQuery({ queryFn: activitiesRequest, queryKey:[queryKeys.Activities],
select: (data) => data?.data.activities
});


export const useGetActivityQuery = (params = {}) => {
  const searchParams = generateUrlSearchString(params);

  return useQuery({
    queryFn: () => getFetch(`${baseURL}/activity/logs?${searchParams}`),
    queryKey: [queryKeys.ActivityLogs, { searchParams }],
    select: (data) => data?.data.activitylogs.activityLogs
  });
};